module.exports = __webpack_public_path__ + "media/60_Long.89d0b9f9.mp3";